export default {"src":"/_next/static/media/directionSign_24.f81cf120.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};